import React, { useState } from "react"
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import ElevatorLoader from "../../Loder/ElevatorLoader";
import CareerPage from '../../Pages/Career/CareerPage';
import CareerBanner from "./CareerBanner";

const ContactUs = () => {
  const [loading, setLoading] = useState(true);
  return (
    <div>
      {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
      <Menu header_style_2={true} />
      <CareerBanner/>
      <CareerPage />
      <FooterThree />
    </div>
  );
};

export default ContactUs;
